export default __webpack_public_path__ + "static/media/x.036704c6.svg";